// 메인 화면 대상 지정 설문 팝업의 "다시 띄우지 않음" 기록.
// - [닫기]               : 이번 접속(탭) 동안만 숨김 → sessionStorage, 로그인할 때마다 초기화
// - [오늘 하루 보지 않기] : 오늘 날짜까지 숨김 → localStorage
const CLOSED_KEY = "survey_popup_closed";
const HIDE_DATE_KEY = "survey_popup_hide_date";

const todayText = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};

export const isSurveyPopupClosed = () => {
  try {
    return sessionStorage.getItem(CLOSED_KEY) === "Y";
  } catch (e) {
    return false;
  }
};

export const setSurveyPopupClosed = (closed) => {
  try {
    if (closed) sessionStorage.setItem(CLOSED_KEY, "Y");
    else sessionStorage.removeItem(CLOSED_KEY);
  } catch (e) {
    // storage 를 쓸 수 없는 환경이면 화면 상태로만 처리
  }
};

// 로그인 성공 시 호출 : 같은 탭에서 다시 로그인해도 팝업이 다시 뜨게 한다
export const clearSurveyPopupClosed = () => setSurveyPopupClosed(false);

export const isSurveyPopupHiddenToday = () => {
  try {
    return localStorage.getItem(HIDE_DATE_KEY) === todayText();
  } catch (e) {
    return false;
  }
};

export const hideSurveyPopupToday = () => {
  try {
    localStorage.setItem(HIDE_DATE_KEY, todayText());
  } catch (e) {
    // no-op
  }
};
